<template>
  <div class="comReport">
    <div class="topTab">
      <div class="topTab_item" :class="{'topTab_item_active':index==activeIndex}" v-for="(item,index) in tab" @click="changeTab(index,item)"  :key="index">
        <p>{{item.name}}</p>
        <span class="line"></span>
      </div>
    </div>
      <div class="bottomTab_t">
      </div>
    <div class="dataList">
      <Scroll
        :data="visitorList"
        :allLoaded="allLoaded"
        @pulldown="loadData"
        @loadUp="loadup"
        v-if="visitorList.length"
      >
      <div class="dataItem" v-for="(item,index) in visitorList" :key="index" @click="details(item.id)">
         <div class="dataItem_line dataItem_line2">
           <span class="line_text">{{item.complainContent}}</span>
         </div>
         <div class="dataItem_line">
         </div>
         <div class="dataItem_line">
           <span class="line_text">{{item.createdAt}}</span>
         </div>
         <div class="dataItem_status" :class="{'status_active1':item.complainStatus==1,'status_active2':item.complainStatus==2,'status_active4':item.complainStatus==4}">{{item.complainStatus|statusFilters}}</div>
      </div>
    </Scroll>
    <nomessage v-if="!visitorList.length"></nomessage>
    </div>
    <div class="bottomBtn_wrap_h">
    </div>
    <div class="bottomBtn_wrap">
      <div class="bottomBtn" @click="add">
        新建投诉
      </div>
    </div>
  </div>
</template>

<script>
import nomessage from '../../components/nomessage';
import { callSpaceUp } from '../../utils/api'
import Scroll from "../../components/scroll";
import util from "../../utils/util";
import { mapState,mapActions } from 'vuex';
export default {
  name:"myRepairOrder",
  data () {
    return {
      activeIndex:0,
      tab:[
        { name:'全部',code:''},
        { name: '待处理', code: '1' },
        { name: '处理中', code: '2' },
        { name: '已关闭', code: '4' }
      ],
      pageNo:1,
      pageSize: 10,
      allLoaded: false, // 可以进行上拉
      loaded: false,
      visitorList:[],
      complainStatus:""
    };
  },
  components: {
    Scroll,
    nomessage
  },
  watch: {
    $route (to, from) {
      console.log("from.name")
      console.log(from.name)
      if (from.name === 'visitDetails') {
        this.pageNo = 1;
        this.fetchData();
      }
    }
  },
  computed: {
    ...mapState({
      // openId: state => state.common.openId,
      userId: state => state.common.userId,
      common: state => state.common,
      marketInfo: state => state.common.marketInfo
    })
  },
  filters:{
    dateFilter(value,util){
      return  value?util.formatTime(value,'11'):''
    },
    statusFilters(status){
      switch (status) {
         case 1:
           return '待处理';
         case 2:
           return '处理中';
         case 4:
           return '已关闭';
       }
    }
  },
  created () {
    this.fetchData()
    this.getComplainType();
  },
  methods: {
    ...mapActions(["getZiDianData"]),
    add(){
      this.$router.push(`/tsComplaint`);
    },
    // 上拉加载
    loadup() {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.fetchData();
    },
    // 下拉刷新
    loadData() {
      this.pageNo = 1;
      util.showLoading()
      this.fetchData();
      this.getComplainType();
    },
    getComplainType() {
      let parmes = {
        companyId:this.common.userInfo.cityId,
        url: "/property/rstRepair/initDictWhenLoginName"
      }
      callSpaceUp(parmes).then(res => {
        console.log(res);
        if (res.res.code == 10000) {
          this.getZiDianData(res.body.data)//缓存全局字典
        }
      });
    },
    fetchData(){
      let postInfo = {
          page:this.pageNo,//	false	普通参数	string		页数
          pageSize:10,//	false	普通参数	string		每页显示条数
          complainant:"",//	false	普通参数	string		单条投诉的id(应PC端需求而约定的)
          renter:"",//	false	普通参数	string		是否租客 1是 2不是
          complainStatus:this.complainStatus,//	false	普通参数	string		投诉状态 1 待处理 2 处理中 3 处理完成 4 已关闭
          complainType:"",//	false	普通参数	string		投诉类型
          complainSource:"",//	false	普通参数	string		投诉来源
          companyId:this.common.userInfo.cityId,//	true	普通参数	string	必输	公司id
          thirdId: this.userId,//	普通参数	string	必输	星商会用户id
          subProjectId:Number(this.common.marketInfo.id),
          platform : "RST",
          url: '/property/rstRepair/queryComplainHeaderPage'
      }
      console.log('postInfo')
      console.log(postInfo)

      callSpaceUp(postInfo).then(res => {
        console.log('投诉列表')
         console.log(res)
         util.hideLoading();
         let data = res.body.data.list;
         if (data.length !== 10) {
           this.allLoaded = true; // 若数据已全部获取完毕
         }
         if (this.pageNo === 1) {
           this.visitorList = data;
         } else {
           this.visitorList = [...this.visitorList, ...data];
         }
      })
    },
    details(id){
      this.$router.push(`/repairComplaintDetails?id=${id}`);
    },
    changeTab(index,item){
      this.activeIndex = index
      this.complainStatus = item.code
      this.pageNo = 1;
      this.fetchData()
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.comReport {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .nomessage{
    width: 100vh;
    height: 100vh;
  }
  .bottomTab{
    width: 100%;
    height: 108px;
    flex-shrink:1;
    position: fixed;
    left: 0;
    bottom: 0;
    .btn{
      width: 694px;
      height: 76px;
      background:rgba(23,64,218,1);
      border-radius:4px;
      font-size:32px;
      font-family:PingFangSC;
      font-weight:400;
      color:rgba(255,255,255,1);
      line-height:76px;
      text-align: center;
      margin: 16px 28px;
    }
  }
  .bottomTab_t{
    width:100%;
    height: 88px;
    opacity: 0;
    flex-shrink:1;
  }
  .topTab{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 88px;
    width: 100%;
    background:rgba(238,238,238,1);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    .topTab_item{
      flex:1;
      font-size:28px;
      color:rgba(153,153,153,1);
      line-height:82px;
      text-align: center;
      .flex();
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .topTab_item_active{
      color: rgba(51, 51, 51, 1);
      .line{
        background:rgba(23,64,218,1);
      }
    }
    .line{
      display: block;
      width:32px;
      height:6px;
      background:#eee;
    }
  }

  .dataList{
    // height: 100vh;
    flex:1;
    height:5rem;
    // margin-top: 108px;
    // .flex();
    // flex-direction: column;
    background:rgba(238,238,238,1);
    .dataItem{
      width:710px;
      height:186px;
      background:rgba(255,255,255,1);
      border-radius:8px;
      margin:20px 20px 0;
      padding:28px;
      box-sizing: border-box;
      position: relative;
      .dataItem_status{
        font-size:24px;
        font-family:PingFangSC;
        font-weight:400;
        line-height:32px;
        position: absolute;
        top: 28px;
        right: 28px;
        color:rgba(153, 153, 153,1);
      }
      .status_active3{
        color:#16BC84;
      }
      .status_active1{
        color:#FFAD5D;
      }
      .status_active2{
        color:#16BC84;
      }
      .status_active4{
        color:#999999;
      }
      .dataItem_line{
        height: 34px;
        margin-bottom:8px;
        .line_title,.line_text{
          font-size:24px;
          font-family:PingFangSC;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:34px;
          display: inline-block;
          margin-right: 28px;
        }
        .line_text{
          width:520px;
          color:rgba(51,51,51,1);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          // line: 2;
        }
        .line_address{
          width: 410px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .dataItem_line2{
        max-height: 64px;
      }
    }
  }
  .main_scroll{
    flex:1;
  }
  .bottomBtn_wrap_h{
    width:100%;
    height:108px;
  }
  .bottomBtn_wrap{
    width:100%;
    height:108px;
    background:rgba(255,255,255,1);
    position: fixed;
    left: 0;
    bottom: 0;
    .bottomBtn{
      width:694px;
      height:76px;
      background:rgba(23,64,218,1);
      border-radius:4px;
      text-align: center;
      line-height: 76px;
      font-size:32px;
      font-family:PingFangSC;
      font-weight:400;
      color:rgba(255,255,255,1);
      margin: 16px 28px;
    }
  }
}

</style>
